import styled from "styled-components"
import { setSelectedKayitliAdres } from "../../features/kayit/kayitSlice";
import { showModal } from "../../features/modal/modalSlice";
import { useDispatch } from "react-redux";
import { MdMoreHoriz } from "react-icons/md";

const Container = styled.div`

    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 20px;
    gap: 20px;
    background-color: ${({theme}) => theme.secondaryBgColor};
    border-radius: 10px;
    position: relative;

    .more{
        position: absolute;
        right: 10px;
        top: 5px;
    } 

    .content-item{
        width: calc(50% - 20px);
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: var(--font-size-sm);
        gap: 5px;

        .title{
            font-weight: var(--font-weight-xl);
        }

        .text{
            font-weight: var(--font-weight-md);
        }
    }

`

const KayitliAdreslerContainerMobile = ({ data, selectFromId, selectedItem, setSelectedItem }) => {

    const dispatch = useDispatch()
  return (
    <Container>
        <div className="content-item">
            <div className="title">Adres Adı</div>
            <div className="text">{data?.addressName}</div>
        </div>

        <div className="content-item">
            <div className="title">İl</div>
            <div className="text">{data?.addressCity}</div>
        </div>

        <div className="content-item">
            <div className="title">İlçe</div>
            <div className="text">{data?.addressTown}</div>
        </div>

        <div className="content-item">
            <div className="title">Adres</div>
            <div className="text">{data?.address}</div>
        </div>
        <div className="more" onClick={() => {dispatch(showModal("adresKayitItemOptions")); dispatch(setSelectedKayitliAdres(data))}}>
              <MdMoreHoriz />
          </div>
    </Container>
  )
}

export default KayitliAdreslerContainerMobile